import { useState } from "react";

import {
  Checkbox,
  InputLabel,
  Button,
} from "@mui/material"

interface Step3Props {
  onNext: () => void;
}

const TERMS_AND_CONDITIONS_URL = "https://docs.google.com/document/d/1DR4vZmqvf54jyXgEpmbEgad66qM6rhZMul6roDNZTAo/preview?tab=t.0#heading=h.711ghasvhksy"

const Step3TermsAndConditions = ({ onNext }: Step3Props) => {
  const [accepted, setAccepted] = useState(false);

  return (
    <div className="w-full max-w-lg mx-auto flex flex-col gap-4">
      <div className="w-full h-[40vh] border rounded overflow-hidden">
        <iframe
          src={TERMS_AND_CONDITIONS_URL}
          title="Termos e Condições"
          className="w-full h-full"
        />
      </div>
      {/*<p className="text-center">
        <button
          onClick={() => window.open(TERMS_AND_CONDITIONS_URL, "_blank")}
          className="text-sm text-muted-foreground hover:text-foreground underline transition-colors"
        >
          Abrir em outra aba do navegador
        </button>
      </p>*/}
      <div className="flex items-center space-x-2">
        <Checkbox
          id="terms"
          checked={accepted}
          onChange={({target}) => setAccepted(!!target.checked)} />

        <InputLabel htmlFor="terms" className="text-sm text-muted-foreground cursor-pointer">
          Aceito os termos e condições de uso
        </InputLabel>
      </div>
      <Button
        className="w-full"
        size="large"
        disabled={!accepted}
        variant='contained'
        onClick={onNext}
      >
        Continuar
      </Button>
    </div>
  );
};

export default Step3TermsAndConditions;
